/* PureAyurBliss PDP scripts */

// Custom size picker — update is-selected CSS, price, availability, and URL on variant change
(function () {
  var productInfo = document.querySelector('product-info');
  if (!productInfo) return;

  var productUrl = productInfo.dataset.url;
  var sectionId = productInfo.dataset.section;
  var priceEl = document.getElementById('price-' + sectionId);

  function getVariantData() {
    var el = document.getElementById('pab-variants-' + sectionId);
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }

  function getSelectedOptions() {
    var opts = [];
    document.querySelectorAll('.pab-size-opts').forEach(function (group) {
      var checked = group.querySelector('input[type="radio"]:checked');
      if (checked) opts.push(checked.value);
    });
    return opts;
  }

  function findVariant(variants, options) {
    return variants.find(function (v) {
      return v.options.length === options.length &&
        v.options.every(function (opt, i) { return opt === options[i]; });
    }) || null;
  }

 function applyVariant(variant) {
  if (!variant) return;

  // Sync the selected variant with Add to Cart and Buy Now.
  var productForm = document.getElementById(
    'product-form-' + sectionId
  );

  if (productForm) {
    var variantInput = productForm.querySelector('input[name="id"]');

    if (variantInput) {
      variantInput.value = String(variant.id);
      variantInput.disabled = !variant.available;
      variantInput.dispatchEvent(
        new Event('change', { bubbles: true })
      );
    }
  }

    // Update URL
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());

    // Use Dawn's section rendering to update price + ATC button
    fetch(productUrl + '?variant=' + variant.id + '&sections=' + sectionId)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[sectionId];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newPrice = doc.getElementById('price-' + sectionId);
        if (newPrice && priceEl) priceEl.innerHTML = newPrice.innerHTML;
        var newBtn = doc.querySelector('.product-form__submit');
        var curBtn = document.querySelector('.product-form__submit');
        if (newBtn && curBtn) {
          curBtn.disabled = newBtn.disabled;
          curBtn.innerHTML = newBtn.innerHTML;
        }
      })
      .catch(function () {});

    // Gallery image sync
    document.dispatchEvent(new CustomEvent('variant:change', {
      detail: {
        variant: {
          id: variant.id,
          featured_media: variant.featured_media_id ? { id: variant.featured_media_id } : null
        }
      }
    }));
  }

  document.querySelectorAll('.pab-size-opts').forEach(function (group) {
    group.addEventListener('change', function () {
      // Update is-selected styling
      group.querySelectorAll('.pab-size-opt').forEach(function (opt) {
        opt.classList.remove('is-selected');
      });
      var checked = group.querySelector('input[type="radio"]:checked');
      if (checked) checked.closest('.pab-size-opt').classList.add('is-selected');

      // Apply variant
      var variant = findVariant(getVariantData(), getSelectedOptions());
      if (variant) applyVariant(variant);
    });
  });
})();

// Custom product gallery
(function () {
  function initGallery(gallery) {
    if (!gallery) return;
    var slides = Array.from(gallery.querySelectorAll('.pab-gallery__slide'));
    var thumbs = gallery.querySelectorAll('.pab-gallery__thumb');
    var indicators = gallery.querySelectorAll('.pab-gallery__indicator');
    var thumbsEl = gallery.querySelector('.pab-gallery__thumbs');
    var thumbsWrap = gallery.querySelector('.pab-gallery__thumbs-wrap');
    var stageEl = gallery.querySelector('.pab-gallery__stage');
    var arrowUp = gallery.querySelector('.pab-thumbs-arrow--up');
    var arrowDown = gallery.querySelector('.pab-thumbs-arrow--down');

    function updateArrows() {
      if (!thumbsEl || !arrowUp || !arrowDown) return;
      var hasOverflow = thumbsEl.scrollHeight > thumbsEl.clientHeight + 2;
      var atTop = thumbsEl.scrollTop <= 2;
      var atBottom = thumbsEl.scrollTop + thumbsEl.clientHeight >= thumbsEl.scrollHeight - 2;
      arrowUp.classList.toggle('is-hidden', !hasOverflow || atTop);
      arrowDown.classList.toggle('is-hidden', !hasOverflow || atBottom);
    }

    // Sync thumbnail wrap height to stage height (desktop only)
    function syncThumbsHeight() {
      if (!thumbsWrap || !stageEl || window.innerWidth <= 900) return;
      thumbsWrap.style.maxHeight = stageEl.offsetHeight + 'px';
      updateArrows();
    }
    window.addEventListener('load', syncThumbsHeight);
    window.addEventListener('resize', syncThumbsHeight, { passive: true });
    setTimeout(syncThumbsHeight, 100);

    if (arrowUp) {
      arrowUp.addEventListener('click', function () {
        if (thumbsEl) thumbsEl.scrollBy({ top: -96, behavior: 'smooth' });
      });
    }
    if (arrowDown) {
      arrowDown.addEventListener('click', function () {
        if (thumbsEl) thumbsEl.scrollBy({ top: 96, behavior: 'smooth' });
      });
    }
    if (thumbsEl) thumbsEl.addEventListener('scroll', updateArrows, { passive: true });

    function show(mediaId) {
      slides.forEach(function (s) { s.classList.toggle('is-active', s.dataset.mediaId === mediaId); });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.mediaId === mediaId); });
      indicators.forEach(function (d) { d.classList.toggle('is-active', d.dataset.mediaId === mediaId); });
      // Scroll active thumb into view and refresh arrow state
      var activeThumb = gallery.querySelector('.pab-gallery__thumb.is-active');
      if (activeThumb && thumbsEl) {
        activeThumb.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        setTimeout(updateArrows, 300);
      }
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { show(this.dataset.mediaId); });
    });

    // Touch swipe for mobile slider
    var stage = gallery.querySelector('.pab-gallery__stage');
    if (stage) {
      var touchStartX = 0;
      stage.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        var delta = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(delta) < 40) return;
        var currentIdx = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
        var nextIdx = delta < 0
          ? Math.min(currentIdx + 1, slides.length - 1)
          : Math.max(currentIdx - 1, 0);
        if (nextIdx !== currentIdx) show(slides[nextIdx].dataset.mediaId);
      }, { passive: true });
    }

    // Sync when Dawn changes variant
    document.addEventListener('variant:change', function (e) {
      var media = e.detail && e.detail.variant && e.detail.variant.featured_media;
      if (media) show(String(media.id));
    });
  }

  initGallery(document.querySelector('.pab-gallery'));
})();

// Subnav: always visible below header + scroll-spy
(function () {
  var nav = document.querySelector('.pab-subnav');
  if (!nav) return;

  var links = Array.from(nav.querySelectorAll('a[href^="#"]'));
  var ids = links.map(function (a) { return a.getAttribute('href').slice(1); });
  var navH = 50;
  var padded = false;

  // Push product-info content below the fixed subnav strip so breadcrumbs aren't hidden
  function addPadding() {
    if (padded) return;
    navH = nav.offsetHeight || 50;
    var pi = document.querySelector('product-info');
    if (pi) { pi.style.paddingTop = navH + 'px'; padded = true; }
  }

  // Called on EVERY scroll — sticky-header.bottom auto-adjusts:
  //   announcement bar visible  → announcement_h + header_h
  //   announcement scrolled away (header now stuck at top:0) → header_h only
  // This means subnav naturally tracks the sticky header at all scroll positions.
  function headerBottom() {
    var sh = document.querySelector('sticky-header');
    if (sh) {
      var b = sh.getBoundingClientRect().bottom;
      if (b > 20 && b < window.innerHeight * 0.5) return Math.round(b);
    }
    var max = 0;
    ['#shopify-section-header', '.header-wrapper', 'header.header'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (!el) return;
      var b = el.getBoundingClientRect().bottom;
      if (b > max && b < window.innerHeight * 0.5) max = b;
    });
    if (max > 20) return Math.round(max);
    // Breadcrumbs fallback at scroll=0 only (subtract the padding we added)
    if (window.scrollY < 5) {
      var bc = document.querySelector('.pab-breadcrumbs');
      if (bc) {
        var t = Math.round(bc.getBoundingClientRect().top);
        if (t > navH) return t - navH;
      }
    }
    return 80;
  }

  function update() {
    var h = headerBottom();
    nav.style.top = h + 'px';
    document.documentElement.style.setProperty('--pab-nav-offset', (h + navH) + 'px');
    var threshold = h + navH + 10;
    var current = ids[0];
    for (var i = 0; i < ids.length; i++) {
      var el = document.getElementById(ids[i]);
      if (el && el.getBoundingClientRect().top <= threshold) current = ids[i];
    }
    links.forEach(function (a) {
      a.classList.toggle('pab-on', a.getAttribute('href') === '#' + current);
    });
  }

  function init() {
    addPadding();
    update();
  }

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', function () { padded = false; init(); }, { passive: true });
  setTimeout(init, 0);
  window.addEventListener('load', function () { setTimeout(init, 200); });
})();

// Sticky ATC show on scroll
(function () {
  const bar = document.getElementById('pab-sticky-atc');
  if (!bar) return;
  window.addEventListener('scroll', () => {
    bar.classList.toggle('pab-show', window.scrollY > 720);
  }, { passive: true });
})();

// Sticky ATC button click — submits the product form
(function () {
  const btn = document.getElementById('pab-sticky-atc-btn');
  if (!btn) return;
  btn.addEventListener('click', () => {
    const submit = document.querySelector('.product-form__submit');
    if (submit) submit.click();
  });
})();

// Fix cart drawer not refreshing after main ATC and routine ADD/BUNDLE clicks.
// Replaces renderContents to update the inner HTML of the live <cart-drawer> element
// without recreating it (recreating destroys the custom element and causes blank items).
(function () {
  customElements.whenDefined('cart-drawer').then(function () {
    var CartDrawer = customElements.get('cart-drawer');
    if (!CartDrawer || CartDrawer.prototype._pabPatched) return;
    CartDrawer.prototype._pabPatched = true;

    CartDrawer.prototype.renderContents = function (parsedState) {
      var sections = (parsedState && parsedState.sections) || {};

      // Update children of the live <cart-drawer> — never replace the element itself.
      if (sections['cart-drawer']) {
        var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        var newInner = doc.querySelector('cart-drawer') || doc.getElementById('CartDrawer');
        if (newInner) this.innerHTML = newInner.innerHTML;
      }
      // Remove is-empty so header/footer stay visible after first add.
      this.classList.remove('is-empty');

      // Update cart icon bubble count.
      if (sections['cart-icon-bubble']) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble) {
          var tmp = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
          var newBubble = tmp.getElementById('cart-icon-bubble');
          if (newBubble) bubble.outerHTML = newBubble.outerHTML;
        }
      }
      // Wire overlay close listener and open drawer (mirrors Dawn's original setTimeout block).
      var self = this;
      setTimeout(function () {
        var overlay = self.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', self.close.bind(self));
        if (typeof self.open === 'function') self.open();
      }, 0);
    };
  });
})();
